/*
 * `cart.js` i `product-form.js` iz novije Dawn verzije zovu `CartPerformance`,
 * a taj fajl nije postojao u temi. Posledica: `ReferenceError` je pucao PRE nego
 * sto se posalje `/cart/change.js`, pa promena kolicine nije radila ni u korpi ni
 * u fioci — ni na serveru, ni u prikazu.
 *
 * Ovo je Shopify-jev merni sloj. Ovde je namerno otporan na greske: merenje je
 * sporedno, a kupovina ne sme da zavisi od njega. `measure` UVEK izvrsi callback,
 * jer upravo on iscrtava osvezene sekcije.
 */
class CartPerformance {
  static #prefix = 'cart-performance';

  static #mark(name, options) {
    try {
      return performance.mark(name, options);
    } catch (e) {
      return { name, startTime: 0 };
    }
  }

  static #measure(metricName, startName, endName) {
    try {
      performance.measure(metricName, startName, endName);
    } catch (e) {}
  }

  static createStartingMarker(benchmarkName) {
    return CartPerformance.#mark(`${CartPerformance.#prefix}:${benchmarkName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#prefix}:${benchmarkName}`;
    const start = CartPerformance.#mark(`${metricName}:start`, { startTime: event && event.timeStamp });
    const end = CartPerformance.#mark(`${metricName}:end`);
    CartPerformance.#measure(metricName, start.name, end.name);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#prefix}:${benchmarkName}`;
    const end = CartPerformance.#mark(`${metricName}:end`);
    if (startMarker && startMarker.name) CartPerformance.#measure(metricName, startMarker.name, end.name);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#prefix}:${benchmarkName}`;
    const start = CartPerformance.#mark(`${metricName}:start`);
    if (typeof callback === 'function') callback();
    const end = CartPerformance.#mark(`${metricName}:end`);
    CartPerformance.#measure(metricName, start.name, end.name);
  }
}

window.CartPerformance = CartPerformance;
